var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.1875,
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#FDF2D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_11589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3222 28.7718C33.3222 30.0846 32.2603 31.1466 30.9474 31.1466H28.3904C27.0776 31.1466 26.0156 30.0846 26.0156 28.7718C26.0156 27.4589 27.0776 26.397 28.3904 26.397H30.9474C32.2603 26.397 33.3222 27.4589 33.3222 28.7718Z",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0918 33.1089C34.0918 34.1915 33.2119 35.0713 32.1294 35.0713H28.7476C27.665 35.0713 26.7852 34.1915 26.7852 33.1089C26.7852 32.0263 27.665 31.1465 28.7476 31.1465H32.1294C33.2119 31.1465 34.0918 32.0263 34.0918 33.1089Z",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9023 36.8034C35.9023 37.7589 35.1256 38.5356 34.1702 38.5356H30.3278C29.3724 38.5356 28.5957 37.7589 28.5957 36.8034C28.5957 35.848 29.3724 35.0713 30.3278 35.0713H34.1702C35.1256 35.0713 35.9023 35.848 35.9023 36.8034Z",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7148 40.2781C37.7148 41.2404 36.9347 42.0205 35.9724 42.0205H32.185C31.2055 42.0205 30.4082 41.2404 30.4082 40.2781C30.4082 39.3158 31.2021 38.5356 32.185 38.5356H35.9724C36.9347 38.5356 37.7148 39.3158 37.7148 40.2781Z",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7769 42.0207L41.4234 41.9348C43.5748 41.9348 45.6403 41.079 47.1594 39.5599L48.7438 39.1647H51.885V25.0739H41.7499L37.3646 19.9703C36.8594 18.9805 35.8386 18.355 34.7286 18.355C32.6321 18.355 31.199 20.4755 31.9791 22.4207L34.4914 26.3971H31.1543",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7793 29.8716C38.7793 29.8716 40.4943 33.2706 46.1649 33.2706",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9831 23.4551H51.8828V40.8968H57.9831V23.4551Z",
    stroke: "#187C85",
    strokeWidth: 0.864386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_11589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 24.6967,
    fill: "white",
    transform: "translate(25.5 17.8394)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibilityIcon);
export default __webpack_public_path__ + "static/media/flexibility-icon.2eb5f89bf9fcc640e2f928e46208a8e8.svg";
export { ForwardRef as ReactComponent };